export default "__VITE_ASSET__But$QTRq__"